import React from "react";
import { SITE } from "../config/siteConfig";
import { HeadsetIcon } from "./icons";

export function Logo() {
  return (
    <a href="/" className="logo" aria-label={SITE.brandName + " - accueil"}>
      <span className="logo-text">
        <b>mes démarches</b>
        <i>energie.fr</i>
      </span>
      <HeadsetIcon />
    </a>
  );
}
